import { Trash2 } from "lucide-react"
import TrBtn from "./TrBtn"

const DeleteButton = () => {
  return (
    <TrBtn text="Delete">
      <span className="text-danger"><Trash2 size={15} /></span>
    </TrBtn>
  )
}

export default DeleteButton